import { getQuestionEventsMetadata } from './common';

const GA_CATEGORY_NAME = 'Question updated';

const questionUpdateEvents = {
  answerUpdated: {
    eventName: 'Answer Updated',
    getMetaData: ({
      cancerType,
    }) => getQuestionEventsMetadata(cancerType),
  },
};

export {
  GA_CATEGORY_NAME,
};

export default questionUpdateEvents;
